import { TouchPointHelper } from '../../../helpers/touchPointHelper';
import { placeholders, displayGroups } from '@ui';

export const subscriptionSelectPlan = {
	prismName: 'subscriptionSelectPlan',
	template: {
		templateName: 'subscriptionSelectPlanTemplate',
		displayGroups: [
			TouchPointHelper.createDisplayGroup(displayGroups.pageContainer, [
				TouchPointHelper.createDisplayGroup(displayGroups.rowContainer, [
					TouchPointHelper.createDisplayGroup(
						displayGroups.leftPanel,
						[],
						[
							TouchPointHelper.createPlaceholder(placeholders.logo, {
								placeholderBuildReference: 10,
							}),
							TouchPointHelper.createPlaceholder(placeholders.wizardMenu, {
								placeholderBuildReference: 100,
							}),
							TouchPointHelper.createPlaceholder(placeholders.doubtsAndExit, {
								placeholderBuildReference: 200,
							}),
						]
					),
					TouchPointHelper.createDisplayGroup(
						displayGroups.columnContainer,
						[
							TouchPointHelper.createDisplayGroup(
								displayGroups.bodyPanel,
								[],
								[
									TouchPointHelper.createPlaceholder(placeholders.promotionalCode, {
										placeholderBuildReference: 10,
									}),
									//DEPRECATED US 867913
									// TouchPointHelper.createPlaceholder(placeholders.integratedSolutionCard, {
									// 	placeholderBuildReference: 20,
									// }),
									TouchPointHelper.createPlaceholder(placeholders.planCards, {
										placeholderBuildReference: 100,
									}),
								]
							),
						],
						[
							TouchPointHelper.createPlaceholder(placeholders.fixedFooter, {
								placeholderBuildReference: 1000,
							}),
							TouchPointHelper.createPlaceholder(placeholders.modals, {
								placeholderBuildReference: 1001,
							}),
						]
					),
				]),
			]),
		],
	},
};
